/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as PaymentRedirectRouteImport } from './routes/payment-redirect'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TwoFactorCheckRouteImport } from './routes/two-factor.check'
import { Route as PasswordResetTokenRouteImport } from './routes/password-reset.$token'
import { Route as AuthFortuneWheelRouteImport } from './routes/_auth.fortune-wheel'
import { Route as AuthCasinoRouteImport } from './routes/_auth.casino'
import { Route as AuthTwoFactorSetupRouteImport } from './routes/_auth.two-factor.setup'
import { Route as AuthTwoFactorDisableRouteImport } from './routes/_auth.two-factor.disable'
import { Route as AuthGameGameIdRouteImport } from './routes/_auth.game.$gameId'

const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentRedirectRoute = PaymentRedirectRouteImport.update({
  id: '/payment-redirect',
  path: '/payment-redirect',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TwoFactorCheckRoute = TwoFactorCheckRouteImport.update({
  id: '/two-factor/check',
  path: '/two-factor/check',
  getParentRoute: () => rootRouteImport,
} as any)
const PasswordResetTokenRoute = PasswordResetTokenRouteImport.update({
  id: '/password-reset/$token',
  path: '/password-reset/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthFortuneWheelRoute = AuthFortuneWheelRouteImport.update({
  id: '/fortune-wheel',
  path: '/fortune-wheel',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCasinoRoute = AuthCasinoRouteImport.update({
  id: '/casino',
  path: '/casino',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTwoFactorSetupRoute = AuthTwoFactorSetupRouteImport.update({
  id: '/two-factor/setup',
  path: '/two-factor/setup',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTwoFactorDisableRoute = AuthTwoFactorDisableRouteImport.update({
  id: '/two-factor/disable',
  path: '/two-factor/disable',
  getParentRoute: () => AuthRoute,
} as any)
const AuthGameGameIdRoute = AuthGameGameIdRouteImport.update({
  id: '/game/$gameId',
  path: '/game/$gameId',
  getParentRoute: () => AuthRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/payment-redirect': typeof PaymentRedirectRoute
  '/sign-in': typeof SignInRoute
  '/casino': typeof AuthCasinoRoute
  '/fortune-wheel': typeof AuthFortuneWheelRoute
  '/password-reset/$token': typeof PasswordResetTokenRoute
  '/two-factor/check': typeof TwoFactorCheckRoute
  '/game/$gameId': typeof AuthGameGameIdRoute
  '/two-factor/disable': typeof AuthTwoFactorDisableRoute
  '/two-factor/setup': typeof AuthTwoFactorSetupRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/payment-redirect': typeof PaymentRedirectRoute
  '/sign-in': typeof SignInRoute
  '/casino': typeof AuthCasinoRoute
  '/fortune-wheel': typeof AuthFortuneWheelRoute
  '/password-reset/$token': typeof PasswordResetTokenRoute
  '/two-factor/check': typeof TwoFactorCheckRoute
  '/game/$gameId': typeof AuthGameGameIdRoute
  '/two-factor/disable': typeof AuthTwoFactorDisableRoute
  '/two-factor/setup': typeof AuthTwoFactorSetupRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/payment-redirect': typeof PaymentRedirectRoute
  '/sign-in': typeof SignInRoute
  '/_auth/casino': typeof AuthCasinoRoute
  '/_auth/fortune-wheel': typeof AuthFortuneWheelRoute
  '/password-reset/$token': typeof PasswordResetTokenRoute
  '/two-factor/check': typeof TwoFactorCheckRoute
  '/_auth/game/$gameId': typeof AuthGameGameIdRoute
  '/_auth/two-factor/disable': typeof AuthTwoFactorDisableRoute
  '/_auth/two-factor/setup': typeof AuthTwoFactorSetupRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/payment-redirect'
    | '/sign-in'
    | '/casino'
    | '/fortune-wheel'
    | '/password-reset/$token'
    | '/two-factor/check'
    | '/game/$gameId'
    | '/two-factor/disable'
    | '/two-factor/setup'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/payment-redirect'
    | '/sign-in'
    | '/casino'
    | '/fortune-wheel'
    | '/password-reset/$token'
    | '/two-factor/check'
    | '/game/$gameId'
    | '/two-factor/disable'
    | '/two-factor/setup'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/payment-redirect'
    | '/sign-in'
    | '/_auth/casino'
    | '/_auth/fortune-wheel'
    | '/password-reset/$token'
    | '/two-factor/check'
    | '/_auth/game/$gameId'
    | '/_auth/two-factor/disable'
    | '/_auth/two-factor/setup'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  PaymentRedirectRoute: typeof PaymentRedirectRoute
  SignInRoute: typeof SignInRoute
  PasswordResetTokenRoute: typeof PasswordResetTokenRoute
  TwoFactorCheckRoute: typeof TwoFactorCheckRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payment-redirect': {
      id: '/payment-redirect'
      path: '/payment-redirect'
      fullPath: '/payment-redirect'
      preLoaderRoute: typeof PaymentRedirectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/two-factor/check': {
      id: '/two-factor/check'
      path: '/two-factor/check'
      fullPath: '/two-factor/check'
      preLoaderRoute: typeof TwoFactorCheckRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/password-reset/$token': {
      id: '/password-reset/$token'
      path: '/password-reset/$token'
      fullPath: '/password-reset/$token'
      preLoaderRoute: typeof PasswordResetTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/fortune-wheel': {
      id: '/_auth/fortune-wheel'
      path: '/fortune-wheel'
      fullPath: '/fortune-wheel'
      preLoaderRoute: typeof AuthFortuneWheelRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/casino': {
      id: '/_auth/casino'
      path: '/casino'
      fullPath: '/casino'
      preLoaderRoute: typeof AuthCasinoRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/two-factor/setup': {
      id: '/_auth/two-factor/setup'
      path: '/two-factor/setup'
      fullPath: '/two-factor/setup'
      preLoaderRoute: typeof AuthTwoFactorSetupRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/two-factor/disable': {
      id: '/_auth/two-factor/disable'
      path: '/two-factor/disable'
      fullPath: '/two-factor/disable'
      preLoaderRoute: typeof AuthTwoFactorDisableRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/game/$gameId': {
      id: '/_auth/game/$gameId'
      path: '/game/$gameId'
      fullPath: '/game/$gameId'
      preLoaderRoute: typeof AuthGameGameIdRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthRouteChildren {
  AuthCasinoRoute: typeof AuthCasinoRoute
  AuthFortuneWheelRoute: typeof AuthFortuneWheelRoute
  AuthGameGameIdRoute: typeof AuthGameGameIdRoute
  AuthTwoFactorDisableRoute: typeof AuthTwoFactorDisableRoute
  AuthTwoFactorSetupRoute: typeof AuthTwoFactorSetupRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthCasinoRoute: AuthCasinoRoute,
  AuthFortuneWheelRoute: AuthFortuneWheelRoute,
  AuthGameGameIdRoute: AuthGameGameIdRoute,
  AuthTwoFactorDisableRoute: AuthTwoFactorDisableRoute,
  AuthTwoFactorSetupRoute: AuthTwoFactorSetupRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  PaymentRedirectRoute: PaymentRedirectRoute,
  SignInRoute: SignInRoute,
  PasswordResetTokenRoute: PasswordResetTokenRoute,
  TwoFactorCheckRoute: TwoFactorCheckRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
